<template lang="pug">
div.filters-wrapper#candidates-filters(:class="{'filters-wrapper_active': showing}" data-test="candidates-filters")
  portal(to='toolbar-extension')
    navTabs(
      :candidatesCount="candidatesCount"
      @changed="resetFilters"
    )
  
  portal(to='candidate-location-menu')
    v-list-item(@click="goToLocation()" link :class="{'app-list-child__item_active': hasLocation}" data-test="c-menu-all").app-list-child__item
      v-list-item-content All
    v-list-item(v-for="location in this.crmCourseLocation" :key="location.ID" link
      @click="goToLocation(location.ID)"
      data-test="c-menu-location"
      :class="{'app-list-child__item_active': model.filters.courseCity[0] === location.ID }"
    ).app-list-child__item
      v-list-item-content {{ location.name }}

  portal(to="candidate-list-top")
    .filters-candidate
      search(
        data-test="candidate-search"
        v-model="model.filters.search" 
        @change="setQuery($event)"
        placeholder='Search by CBR account, client name, data etc…'
      ).search
      div(v-for="(labelSection, index) in everyLabels" :key="`${index}${$route.name}`").mr-2
        div(v-for="(item, index) in labelSection")
          app-label(
            v-if="labelsMap[item]"
            :keyValue="item" 
            :label="labelsMap[item].label" 
            :isBtn="false"
            :color="labelsMap[item].color"
          )
            template(v-slot:prepend="labelproprs" v-if="labelsMap[item].exclude")
              v-icon(x-small color="white").mr-1.block mdi-alert-outline
      div.candidates-labels
        labels(
          :items="labelItems" 
          ref="labels" itemValue="key" 
          :value="labels" 
          @changed="setLabels"
          @changed:exclude="setLabelsExclude"
        )
        customLabels(
          :value="selectedCustomLabels" 
          @changed="setCustomLabels" 
          @changed:exclude="setCustomLabelsExclude"
        )

      v-checkbox(
        v-model="model.filters.hasAvaliableSlots" 
        label="Avaliable slots" hide-details @change="setQuery"
      ).mr-2.c-checkbox
      v-btn(:outlined="showing" color="primary" data-test="candidates-filters-btn" @click="toggleFilters").text-capitalize.btn-commmon_bold 
        v-icon(left v-if="!showing") mdi-cog
        v-icon(left v-if='showing') mdi-close
        | filters

  portal(to="candidate-filters-chips")
    filters-chips(
      :model="model"
      @remove="removeFilter"
      @remove:multiple="removeFilterMultiple"
    )

  candidates-list-filters(
    :filters="filters" 
    @changeMultiple="selectMultiple" 
    @change="setFilter"
    @filterChanged="startFiltering"
  )
  //- portal(to="candidates-account")
  //-   //- select-menu(
  //-   //-   :options="$store.state.cbrUser.items" 
  //-   //-   itemText="username"
  //-   //-   itemValue="ID" 
  //-   //-   @change="selectMultiple('cbrUser', $event)"
  //-   //- )
  //-   select-menu(
  //-     :getOptions="true" 
  //-     @change="selectMultiple('examProduct', $event)"
  //-   )

  .filters-content
    v-card.filters-wrapper__card
      .filters-top.d-flex.align-center
        h3.filters-top__title Filters
        v-spacer
        v-btn(outlined color="primary" data-test='candidates-filters-close' @click="toggleFilters").btn-common.btn-commmon_bold 
            v-icon(left) mdi-close
            | Close

      v-expansion-panels(:multiple="true" :value="[0, 1]")
        v-expansion-panel.filters-pannel.expansion-panel
          v-expansion-panel-header(data-test="candidates-filters-details").form-title By Candidate Details
          v-expansion-panel-content.expansion-panel__content 
            autocomplete-filter(
              v-model="filters.cbrStatus"
              :model="model"
              multiple
              showCloseMenuBtn
              closeOnInputClick
              field="cbrStatus"
              label="CBR status"
              data-test="filter-cbrstatus"
            )
            autocomplete-filter(
              v-model="filters.courseCity"
              :model="model"
              multiple
              showCloseMenuBtn
              closeOnInputClick
              item-value="ID" 
              item-text="name"
              field="courseCities"
              label="Course location"
            )
            datepicker(
              v-model="filters.courseDateAfter"
              label="Course date from"
            )
            datepicker(
              v-model="filters.courseDateBefore"
              label="Course date to"
            )
            autocomplete-filter(
              v-model="filters.cbrUser"
              item-text="username"
              item-value="ID"
              :model="model"
              multiple
              showCloseMenuBtn
              closeOnInputClick
              field="cbrUsers"
              label="CBR user"
            )
            autocomplete-filter(
              v-model="filters.examProduct"
              :model="model"
              multiple
              showCloseMenuBtn
              closeOnInputClick
              field="examProducts"
              label="Product name"
              itemText="name"
              itemValue="name" 
            )
            v-text-field(
              v-model="filters.lastError"
              label="Last error"
            )
        v-expansion-panel.expansion-panel
          
          v-expansion-panel-header.form-title By Exam Reservation
          v-expansion-panel-content.expansion-panel__content
            autocomplete-filter(
              v-model="filters.queueExamLocation"
              :model="model"
              multiple
              showCloseMenuBtn
              closeOnInputClick
              field="queueExamLocation"
              label="Queue exam location"
            )
            datepicker(
              v-model="filters.queueExamDateAfter"
              label="Queue date from"
            )
            datepicker(
              v-model="filters.queueExamDateBefore"
              label="Queue date to"
            )
            v-checkbox(
              v-model="filters.queueExamDateStrict"
              label="Queue date strict"
              hide-details
            )
            datepicker(
              v-model="filters.queueTimeAfter"
              label="Queue time from"
              icon='mdi-clock-outline'
              convertToDefault=false
              timepicker
            )
            datepicker(
              v-model="filters.queueTimeBefore"
              label="Queue time to"
              icon='mdi-clock-outline'
              convertToDefault=false
              timepicker
            )
            v-combobox(
              :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
              :value="filters.examRequestsCount"
              @update:search-input="(val) => filters.examRequestsCount = val"
              label="Exam requests count"
              name="examRequest"
              clearable
              :menu-props="{contentClass: 'menu-with-scroll-visible'}"
            )
              <template v-slot:append v-if="filters.examRequestsCount" >
                v-icon(color="primary") mdi-check-circle
              </template>
            autocomplete-filter(
              v-model="filters.city"
              :model="model"
              multiple
              showCloseMenuBtn
              closeOnInputClick
              field="cities"
              label="Exam location"
            )
            
            datepicker(
              v-model="filters.examDateAfter"
              label="Exam date from"
            )
            datepicker(
              v-model="filters.examDateBefore"
              label="Exam date to"
            )
            datepicker(
              v-model="filters.examTimeAfter"
              label="Exam time from"
              icon='mdi-clock-outline'
              convertToDefault=false
              timepicker
            )
            datepicker(
              v-model="filters.examTimeBefore"
              label="Exam time to"
              icon='mdi-clock-outline'
              convertToDefault=false
              timepicker
            )

    .filters-actions
        v-spacer
        v-btn(outlined color="primary" @click="toggleFilters").btn-common.btn-commmon_bold.filters-actions__cancel 
          | cancel
        v-btn(color="primary" @click="startFiltering" data-test='filters-submit').text-capitalize
          v-icon(left) mdi-magnify
          | Apply
      
</template>

<script>
import {mapGetters} from "vuex"

import {convertToDefaultDateFormat} from "@/util"
import FiltersModel from "../core/models/candidatesFiltersModel.js"
import { LABELS, FILTERS_ARGS } from '../core/candidates-const'
import CandidatesCount from '../core/models/candidatesCountModel'
import LabelService from "@/app/admin/models/LabelService"

export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    },
    candidatesCount: {
      type: null
    }
  },

  data: () => ({
    model: {},
    filters: {
      city:  [],
      courseCity: [],
      queueExamLocation: [],
      examProduct: [],
      search: [],
      cbrUser: [],
      inQueue: undefined,
      failed: undefined,
      onHold: undefined,
      cbrStatus: [],
      failedExact: undefined,
      inExchangeQueue: undefined,
      wasExchanged: undefined,
      queueExamDateAfter: '',
      queueExamDateBefore: '',
      examDateBefore:  '',
      examDateAfter: '',
      examTimeBefore: '',
      examTimeAfter: '',
      examRequestsCount: null,
      queueExamDateStrict: false,
      queueTimeAfter: '',
      queueTimeBefore: '',
      lastError: ''
    }
  }),

  inject: ['getDefaultPagination'],

  computed: {
    ...mapGetters({
      crmCourseLocation: 'crmCourseCities/items',
      customLabels: 'labels/items'
    }),

    hasLocation() {
      if(this.model.filters.courseCity && !this.model.filters.courseCity.length) return true
      return false
    },

    labelItems() {
      return [
        {
          key: LABELS.NO_DATES,
          label: 'no dates',
          color: '#fb8c00'
        },
        {
          key: LABELS.NO_CANDIDATE_NUMBER,
          label: 'no CDN',
          color: '#888a95'
        },
        {
          key: LABELS.RESERVATION_ERROR,
          label: 'reservation error',
          color: '#b80000'
        },
        {
          key: LABELS.ACCEPTANCE_ERROR,
          label: 'acceptance error',
          color: '#520000'
        },
        {
          key: LABELS.EXCHANGE_ERROR,
          label: 'exchange error',
          color: '#8a0e67'
        },
        {
          key: LABELS.IN_QUEUE,
          label: 'in queue',
          color: '#cfe815'
        },
        {
          key: LABELS.IS_IN_EXCHANGE_QUEUE,
          label: 'exchange queue',
          color: '#fc03b6'
        },
        {
          key: LABELS.NEW_RESERVE,
          label: 'new reserve',
          color: '#78dfa6'
        },
        {
          key: LABELS.NEW_EXCHANGE,
          label: 'new exchange',
          color: '#249a59'
        },
        {
          key: LABELS.IS_MIJN_RESERVATION,
          label: 'mijn reservation',
          color: '#3c16e9'
        },
        {
          key: LABELS.BAD_EXAM,
          label: 'bad exam',
          color: '#ff0000'
        },
      ]
    },

    labelsMap() {
      let items = {}
      this.labelItems.forEach(item => {
        items[item.key] = {
          label: item.label,
          color: item.color,
          exclude: this.model.labels.length ? false: true
        }
      })
      if(!this.customLabels) return items
      this.customLabels.forEach(item => {
        items[item.ID] = {
          label: item.name,
          color: item.color,
          exclude: this.model.customLabels.length ? false : true
        }
      })
      return items
    },

    everyLabels() {
      let labels = []
      let everyLabels = [...this.labels, ...this.selectedCustomLabels]
      everyLabels.forEach((label, index) => {
        if(index % 2 == 0) {
          labels.push([label])
          return
        } 
        labels[labels.length - 1].push(label)
      })
      return labels.reverse()
    },

    labels() {
      if(this.model.labelsExclude.length) return this.model.labelsExclude
      return this.model.labels
    },

    selectedCustomLabels() {
      if(this.model.customLabelsExclude.length) return this.model.customLabelsExclude
      return this.model.customLabels
    }

    
  },

  created() {
    this.initFilters()
  },

  methods: {

    initFilters() {
      this.model = new FiltersModel(this.$route.query)
      this.setFilters()
    },

    async loadOptions() {
      await this.model.loadFilterOptions(this.$store)
    },


    async startFiltering() {
      this.setFiltersToModel()
      await this.setQuery()
      this.hideFilters()
    },

    setFiltersToModel() {
      for(let filter in this.filters) {
        if(filter in this.model.filters) {
          this.model.filters[filter] = this.filters[filter]
        }
      }
    },

    async setQuery(e) {
      await this.$router.replace({query: { ...this.$route.query, ...this.getDefaultPagination(), ...this.model.getApiData()}})
      this.$emit('filterChanged')
    },

    goToLocation(location) {
      this.model.filters.courseCity = location ? [location] : []
      this.filters.courseCity = this.model.filters.courseCity
      this.setQuery()
    },

    async setQueryByParams(params) {
      await this.$router.replace({query: params})
      this.$emit('filterChanged')
    },

    hideFilters() {
      this.$emit('update:showing', false)
    },

    toggleFilters() {
      this.$emit('update:showing', !this.showing)
      if(!this.showing === true) this.loadOptions()
    },

    setFilters() {
      for(let filter in this.filters) {
        if(filter in this.model.filters) {
          this.filters[filter] = this.model.filters[filter]
        }
      }
    },

    removeFilterMultiple(field) {
      this.filters[field] = []
      this.model.filters[field] = []
      this.setQuery()
    },

    removeFilter(field) {
      this.filters[field] = undefined
      this.model.filters[field] = undefined
      this.setQuery()
    },

    setLabels(labels) {
      this.model.labels = [...labels]
      this.model.labelsExclude = []
      this.setQuery()
    },

    setLabelsExclude(labels) {
      this.model.labels = []
      this.model.labelsExclude = [...labels]
      this.setQuery()
    },

    setCustomLabels(labels) {
      this.model.customLabels = [...labels]
      this.model.customLabelsExclude = []
      this.setQuery()
    },

    setCustomLabelsExclude(labels) {
      this.model.customLabels = []
      this.model.customLabelsExclude = [...labels]
      this.setQuery()
    },

    resetFilters() {
      let location = this.model.filters.courseCity
      let search = this.model.search
      this.model.reset()
      this.model.filters.courseCity = location
      this.setFilters()
      this.model.search = search
      this.$refs.labels.setLabels()
    },

    emitRefresh() {
      this.$emit('refreshClicked')
    },

    selectMultiple({field, value}) {
      if(this.filters[field].includes(value)) return
      this.filters[field].push(value)
      this.startFiltering()
    },

    setFilter({field, value}) {
      this.filters[field] = value
      this.startFiltering()
    }
  },

  watch: {
    showing(showing) {
      if(showing) this.setFilters()
    },
  },

  components: {
    datepicker: () => import('./filters/CandidateDatepickerFilters.vue'),
    autocompleteFilter: () => import('./filters/CandidateAutocompleteFilter.vue'),
    search: () => import('@/components/global/Search.vue'),
    filtersChips: () => import('./filters/CandidateFiltersChips.vue'),
    labels: () => import('./candidates/CandidatesLabels.vue'),
    candidatesListFilters: () => import('./filters/CandidatesListFilters.vue'),
    selectMenu: () => import('./filters/CandidatesSelectMenu.vue'),
    labelCreate: () => import('@/app/admin/components/LabelCreate.vue'),
    appLabel: () => import('@/components/global/Label.vue'),
    customLabels: () => import('./CandidatesCustomLabels.vue'),
    navTabs: () => import('./candidates/CandidatesTabs.vue')

  }
}
</script>

<style lang="scss" scoped>
.filters-wrapper {
  z-index: 1;
  // transition: all .3s ease-in;
  position: fixed;
  right: 0;
  top: 112px;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 12px;

  width: 0;
  background: $default-bg-color;
  height: 100vh;
  &_active {
    padding-left: 14px;
    padding-right: 14px;
    width: 30%;
    @media(max-width: 767px) {
      width: 80%;
    }
  }
  &::v-deep {
    .v-expansion-panel-content__wrap {
      padding: 14px;
    }
  }
  &__card {
    height: calc(100vh - 136px);
    overflow-y: auto;
    padding-bottom: 70px;
  }
}

.filters-content {
  position: relative;
}

.filters-top {
  padding: 14px;
  border-bottom: 1px solid $border-color;
  &__title {
    font-size: 18px;
    font-weight: normal;
  }
}
.v-expansion-panel::before, .v-expansion-panel::after {
  display: none;
}
.v-expansion-panel-header {
  padding: 14px;
}

.filters-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 14px;
  display: flex;
  z-index: 1;
  background: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top: 1px solid $border-color;
  &__cancel {
    margin-right: 14px;
  }
}

.filters-candidate {
  padding-top: 14px;
  padding-left: 3px;
  padding-right: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid $border-color;
  display: flex;
  align-items: center;

}
.search {
  margin-right: 15px !important;
}
.search::v-deep {
  &.v-input .v-text-field__slot input {
    padding: 8px 0 8px;
    // padding: 0 !important;
  }
}
.c-checkbox {
  margin-top: 0;
  display: flex;
  align-items: center;
}

.candidates-labels {
  display: flex;
}

@media (max-width: 767px) {
  .filters-candidate {
    flex-wrap: wrap;
  }
  .search {
    width: 100%;
  }
  .candidates-labels {
    width: 100%;
    justify-content: space-between;
  }
}
</style>